import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton, FormControlLabel, FormControl, RadioGroup, Radio } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import Select from "react-select";
import { RxCross2 } from "react-icons/rx";
import { incidentSeverityOptions, incidentTypeOptions, contractorOptions, statusOptions, responsiblePersonData, verificationBYData } from "helpers/incidentOption";
import { useUpdateIncidentMutation } from "store/slices/apis/incidentTrackerSlice";
import CustomTabs from "components/CustomTabs";
import DocumentManagement from "components/DocumentManagement";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
// const tabs = ["Incident Information", "Documents"]

const EditIncident = (props) => {
    const { open, handleClose, incidentData, refetchCounts } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [updateIncident] = useUpdateIncidentMutation()
    const [tabValue, setTabValue] = useState(0);

    const { data: contactsData, isLoading, error } = useGetAllContactsQuery();

    const module = "Incident"
    const { data: contractorNameData } = useGetMasterDataQuery({ module: module, category: 'ContractorName', ProjectId: projectId });
    const { data: incidentSeverityData } = useGetMasterDataQuery({ module: module, category: 'IncidentSeverityRating', ProjectId: projectId });
    const { data: typeofIncidentData } = useGetMasterDataQuery({ module: module, category: 'TypeofIncident', ProjectId: projectId });
    const { data: incidentStatusData } = useGetMasterDataQuery({ module: module, category: 'IncidentStatus', ProjectId: projectId });
    const { data: verificationDoneByData } = useGetMasterDataQuery({ module: module, category: 'VerificationDoneBy', ProjectId: projectId });

    const responsiblePersonData = contractorNameData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const incidentSeverityOptions = incidentSeverityData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const incidentTypeOptions = typeofIncidentData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const verificationBYData = verificationDoneByData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const statusOptions = incidentStatusData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];



    const responsiblePersonOptions = React.useMemo(() => {
        if (!contactsData?.data) return [];

        return contactsData.data.map((item) => ({
            value: item.email,
            label: `${item.name}`,
        })).sort((a, b) => a.label.localeCompare(b.label));
    }, [contactsData]);

    const [initialFormData, setInitialFormData] = useState({
        contractorName: "",
        incidentType: "",
        incidentDescription: "",
        location: "",
        incidentTime: null,
        dateincident: null,
        incidentSeverityRating: "",
        personalInvolved: "",
        injuryDetails: "",
        ltiDaysLost: null,
        immediateActionTaken: "",
        rootCauseIdentified: "",
        capa: "",
        responsiblePerson: "",
        dateClosure: null,
        capaStatus: "",
        verificationDoneBy: "",
        projectId: projectId,
        status: ""
    });

    const formatDateForInput = (dateString) => {
        if (!dateString) return null;
        return moment(dateString).format("YYYY-MM-DD");
    };

    const formatDateTimeForInput = (dateString, timeString) => {
        if (!dateString || !timeString) return null;

        const datePart = moment.utc(dateString).local().format("YYYY-MM-DD");
        const timePart = moment(timeString, "HH:mm:ss").format("HH:mm");
        return `${datePart}T${timePart}`;
    };

    const formatTimeForInput = (timeString) => {
        if (!timeString) return null;
        return moment(timeString, "HH:mm:ss").format("HH:mm");
    };

    useEffect(() => {
        if (incidentData && open) {
            const formattedData = {
                contractorName: incidentData.contractorName || "",
                incidentType: incidentData.typeOfIncident || "",
                incidentDescription: incidentData.descriptionOfIncident || "",
                location: incidentData.location || "",
                incidentTime: formatTimeForInput(incidentData.timeOfIncident),
                dateincident: incidentData.dateOfIncident
                    ? moment(incidentData.dateOfIncident).format("YYYY-MM-DDTHH:mm")
                    : null,
                incidentSeverityRating: incidentData.incidentSeverityRating || "",
                personalInvolved: incidentData.personnelInvolved || "",
                injuryDetails: incidentData.injuryDetails || "",
                ltiDaysLost: incidentData.ltiDaysLost || null,
                immediateActionTaken: incidentData.immediateActionTaken || "",
                rootCauseIdentified: incidentData.rootCauseIdentified || "",
                capa: incidentData.correctiveAndPreventiveAction || "",
                responsiblePerson: incidentData.responsiblePerson || "",
                dateClosure: formatDateForInput(incidentData.dateOfClosure),
                capaStatus: incidentData.capaStatus || "",
                verificationDoneBy: incidentData.verificationDoneBy || "",
                projectId: projectId,
                status: incidentData.status || "",
            };
            setInitialFormData(formattedData);
        }
    }, [incidentData, open, projectId]);

    const validationSchema = Yup.object({
        contractorName: Yup.string().required("Contractor Name is required"),
        incidentType: Yup.string().required("Type of Incident is required"),
        incidentDescription: Yup.string().required("Description of Incident is required"),
        location: Yup.string().required("Location is required"),
        // incidentTime: Yup.string().required("Time of Incident is required"),
        dateincident: Yup.date().required("Date of Incident is required"),
        status: Yup.string().required("Status is required"),
        // incidentSeverityRating: Yup.string().required("Incident Severity Rating is required"),
        // personalInvolved: Yup.string().required("Personal Involved is required"),
        // injuryDetails: Yup.string().required("Injury Details is required"),
        // ltiDaysLost: Yup.number().typeError("LTI Days Lost must be a number").integer("LTI Days Lost must be an integer").positive("LTI Days Lost must be positive"),
        // immediateActionTaken: Yup.string().required("Immediate Action Taken is required"),
        // rootCauseIdentified: Yup.string().required("Root Cause Identified is required"),
        // capa: Yup.string().required("CAPA is required"),
        // responsiblePerson: Yup.string().required("Responsible Person is required"),
        // dateClosure: Yup.date(),
        capaStatus: Yup.string().required("CAPA Status is required"),
        // verificationDoneBy: Yup.string().required("Verification Done By is required"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        let reqBody = {
            incidentTrackerId: incidentData?.incidentTrackerId,
            projectId: projectId,
            contractorName: values?.contractorName,
            dateOfIncident: values?.dateincident ? moment.utc(values?.dateincident, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            timeOfIncident: values?.incidentTime,
            location: values?.location,
            typeOfIncident: values?.incidentType,
            descriptionOfIncident: values?.incidentDescription,
            incidentSeverityRating: values?.incidentSeverityRating,
            personnelInvolved: values?.personalInvolved,
            injuryDetails: values?.injuryDetails,
            ltiDaysLost: values?.ltiDaysLost ? parseInt(values.ltiDaysLost) : null,
            immediateActionTaken: values?.immediateActionTaken,
            rootCauseIdentified: values?.rootCauseIdentified,
            correctiveAndPreventiveAction: values?.capa,
            responsiblePerson: values?.responsiblePerson,
            dateOfClosure: values?.dateClosure ? moment.utc(values?.dateClosure, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            capaStatus: values?.capaStatus,
            verificationDoneBy: values?.verificationDoneBy,
            status: values?.status,
            isActive: true
        };
        console.log("edithse", reqBody)

        try {
            const response = await updateIncident({ body: reqBody }).unwrap();
            openNotification("Incident updated successfully", "success");
            setSubmitting(false);
            refetchCounts()
            handleClose();

        } catch (error) {
            openNotification(error?.error ?? "Something went wrong", "error");
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                    lineHeight: "100%",
                    color: "#140F36",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    Edit Incident
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],

                    })}
                >
                    <RxCross2 size={30} color="#140F36" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    {/* <CustomTabs tabValue={tabValue} handleTabChange={handleTabChange} tabs={tabs} />
                    {tabValue === 0 && */}
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <Formik
                                enableReinitialize={true}
                                initialValues={initialFormData}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    setFieldTouched }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Grid container spacing={2}>
                                            <Grid size={12}>
                                                <Typography sx={{ mt: 1, mb: 0, fontSize: "22px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                                                    Incident Details
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Contractor Name
                                                </Typography>
                                                <Select
                                                    name="contractorName"
                                                    options={responsiblePersonData}
                                                    value={responsiblePersonData.find(opt => opt.value === String(values.contractorName)) || null}
                                                    onChange={(option) => setFieldValue("contractorName", option.value)}
                                                    onBlur={() => setFieldTouched("contractorName", true)}
                                                    placeholder="Select Contractor Name"
                                                />
                                                {touched.contractorName && errors.contractorName && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.contractorName}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Type of Incident
                                                </Typography>
                                                <Select
                                                    name="incidentType"
                                                    options={incidentTypeOptions}
                                                    value={incidentTypeOptions.find(opt => opt.value === String(values.incidentType)) || null}
                                                    onChange={(option) => setFieldValue("incidentType", option.value)}
                                                    onBlur={() => setFieldTouched("incidentType", true)}
                                                    placeholder="Select Type of Incident"
                                                />
                                                {touched.incidentType && errors.incidentType && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.incidentType}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Typography sx={labelTextStyle}>Description of Incident</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="incidentDescription"
                                                    value={values.incidentDescription}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    multiline
                                                    rows={3}
                                                    placeholder="Enter Description of Incident"
                                                    InputProps={{
                                                        sx: {
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& textarea::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& textarea": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.incidentDescription && errors.incidentDescription && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.incidentDescription}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Location
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    name="location"
                                                    value={values.location}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Enter Verification Done By"
                                                    InputProps={{
                                                        sx: {
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& input::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& input": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                            },

                                                        },
                                                    }}
                                                />
                                                {touched.location && errors.location && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.location}
                                                    </Typography>
                                                )}
                                            </Grid>



                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                    Date/Time of Incident
                                                </Typography>
                                                <TextField
                                                    type="datetime-local"
                                                    name="dateincident"
                                                    value={values.dateincident}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onClick={(e) => {
                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="datetime-local"]');
                                                        if (input) input.showPicker?.();
                                                    }}
                                                    fullWidth
                                                    sx={{
                                                        ...rightTextStyle,
                                                        "& input::-webkit-calendar-picker-indicator": {
                                                            display: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& input[type='datetime-local']": {
                                                            appearance: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                {calenderSVG}
                                                            </Box>
                                                        ),
                                                        sx: {
                                                            backgroundColor: "#fff",
                                                            border: '1px solid',
                                                            borderColor: 'hsl(0, 0%, 80%)',
                                                            height: "40px",
                                                            width: { xs: "100%", md: "100%" },
                                                            borderRadius: "5px",
                                                        },
                                                    }}
                                                />
                                                {touched.dateincident && errors.dateincident && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.dateincident}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>LTI Days Lost</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="ltiDaysLost"
                                                    value={values.ltiDaysLost}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Enter LTI Days Lost"
                                                    InputProps={{
                                                        sx: {
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& input::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& input": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.ltiDaysLost && errors.ltiDaysLost && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.ltiDaysLost}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Incident Severity Rating
                                                </Typography>
                                                <Select
                                                    name="incidentSeverityRating"
                                                    options={incidentSeverityOptions}
                                                    value={incidentSeverityOptions.find(opt => opt.value === String(values.incidentSeverityRating)) || null}
                                                    onChange={(option) => setFieldValue("incidentSeverityRating", option.value)}
                                                    onBlur={() => setFieldTouched("incidentSeverityRating", true)}
                                                    placeholder="Select Severity Rating"
                                                />
                                                {touched.incidentSeverityRating && errors.incidentSeverityRating && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.incidentSeverityRating}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>Personnel Involved</Typography>
                                                <Select
                                                    name="personalInvolved"
                                                    options={responsiblePersonOptions}
                                                    value={responsiblePersonOptions.find(opt => opt.value === String(values.personalInvolved)) || null}
                                                    onChange={(option) => setFieldValue("personalInvolved", option.value)}
                                                    onBlur={() => setFieldTouched("personalInvolved", true)}
                                                    placeholder="Select Personnel Involved"
                                                />
                                                {touched.personalInvolved && errors.personalInvolved && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.personalInvolved}
                                                    </Typography>
                                                )}
                                            </Grid>



                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Responsible Person
                                                </Typography>
                                                <Select
                                                    name="responsiblePerson"
                                                    options={responsiblePersonOptions}
                                                    value={responsiblePersonOptions.find(opt => opt.value === String(values.responsiblePerson)) || null}
                                                    onChange={(option) => setFieldValue("responsiblePerson", option.value)}
                                                    onBlur={() => setFieldTouched("responsiblePerson", true)}
                                                    placeholder="Select Responsible Person"
                                                />
                                                {touched.responsiblePerson && errors.responsiblePerson && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.responsiblePerson}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>Root Cause Identified</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="rootCauseIdentified"
                                                    value={values.rootCauseIdentified}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Enter Root Cause Identified"
                                                    InputProps={{
                                                        sx: {
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& input::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& input": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.rootCauseIdentified && errors.rootCauseIdentified && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.rootCauseIdentified}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>Immediate Action Taken</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="immediateActionTaken"
                                                    value={values.immediateActionTaken}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Enter Root Cause Identified"
                                                    InputProps={{
                                                        sx: {
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& input::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& input": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.immediateActionTaken && errors.immediateActionTaken && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.immediateActionTaken}
                                                    </Typography>
                                                )}
                                            </Grid>



                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>CAPA(Corrective and Preventive Action)</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="capa"
                                                    value={values.capa}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    multiline
                                                    rows={2}
                                                    placeholder="Enter CAPA"
                                                    InputProps={{
                                                        sx: {
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& textarea::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& textarea": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.capa && errors.capa && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.capa}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>Injury Details</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="injuryDetails"
                                                    value={values.injuryDetails}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    multiline
                                                    rows={2}
                                                    placeholder="Enter Injury Details"
                                                    InputProps={{
                                                        sx: {
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& textarea::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& textarea": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.injuryDetails && errors.injuryDetails && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.injuryDetails}
                                                    </Typography>
                                                )}
                                            </Grid>



                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    CAPA Status
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    name="capaStatus"
                                                    value={values.capaStatus}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Enter Verification Done By"
                                                    InputProps={{
                                                        sx: {
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& input::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& input": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                            },

                                                        },
                                                    }}
                                                />
                                                {touched.capaStatus && errors.capaStatus && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.capaStatus}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>Verification Done By</Typography>
                                                <Select
                                                    name="verificationDoneBy"
                                                    options={verificationBYData}
                                                    value={verificationBYData.find(opt => opt.value === String(values.verificationDoneBy)) || null}
                                                    onChange={(option) => setFieldValue("verificationDoneBy", option.value)}
                                                    onBlur={() => setFieldTouched("verificationDoneBy", true)}
                                                    placeholder="Select VerificationDoneBy"
                                                />
                                                {touched.verificationDoneBy && errors.verificationDoneBy && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.verificationDoneBy}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Status
                                                </Typography>
                                                <Select
                                                    name="status"
                                                    options={statusOptions}
                                                    value={statusOptions.find(opt => opt.value === String(values.status)) || null}
                                                    onChange={(option) => setFieldValue("status", option.value)}
                                                    onBlur={() => setFieldTouched("status", true)}
                                                    placeholder="Select Status"
                                                />
                                                {touched.status && errors.status && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.status}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                    Date of Closure
                                                </Typography>
                                                <TextField
                                                    type="date"
                                                    name="dateClosure"
                                                    value={values.dateClosure}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onClick={(e) => {
                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                        if (input) input.showPicker?.();
                                                    }}
                                                    fullWidth
                                                    sx={{
                                                        ...rightTextStyle,
                                                        "& input::-webkit-calendar-picker-indicator": {
                                                            display: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& input[type='date']": {
                                                            appearance: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                {calenderSVG}
                                                            </Box>
                                                        ),
                                                        sx: {
                                                            backgroundColor: "#fff",
                                                            border: '1px solid',
                                                            borderColor: 'hsl(0, 0%, 80%)',
                                                            height: "40px",
                                                            width: { xs: "100%", md: "100%" },
                                                            borderRadius: "5px",
                                                        },
                                                    }}
                                                />
                                                {touched.dateClosure && errors.dateClosure && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.dateClosure}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            <Grid size={12}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                        gap: 2,
                                                    }}
                                                >
                                                    <Button onClick={handleClose}
                                                        sx={{
                                                            textTransform: "none",
                                                            color: "#F15744",
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontFamily: "Outfit, sans-serif",
                                                            borderRadius: "25px",
                                                            fontWeight: 500,
                                                            px: "20px",
                                                            py: "15px",
                                                        }}>
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        disabled={isSubmitting}
                                                        sx={{
                                                            backgroundColor: "#00344C",
                                                            borderRadius: "25px",
                                                            textTransform: "none",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontFamily: "Outfit, sans-serif",
                                                            color: "#FFFFFF",
                                                            px: "20px",
                                                            py: "15px",
                                                            '&:disabled': {
                                                                backgroundColor: '#cccccc',
                                                            }
                                                        }}
                                                    >
                                                        {isSubmitting ? "Updating..." : "Update"}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            </Formik>
                        </Grid>
                    </Grid>
                    {/* } */}

                    {/* {tabValue === 1 &&
                        <Grid size={{ md: 12, xs: 12 }}>
                            <DocumentManagement id={incidentData?.incidentId} entityType="Incident" customId={incidentData?.customId} />
                        </Grid>
                    } */}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default EditIncident;